import { render, staticRenderFns } from "./Devtools.vue?vue&type=template&id=5fd040de"
import script from "./Devtools.vue?vue&type=script&lang=js"
export * from "./Devtools.vue?vue&type=script&lang=js"
import style0 from "./Devtools.vue?vue&type=style&index=0&id=5fd040de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports